import { get, urlApiTegra } from "../../../service/api";

const getCollaboratorChartsDate = (token: string, query: string) => {
  return get(`${urlApiTegra}/users/chart?${query}`, token);
};

const getProjectsChartsDate = (token: string, query: string) => {
  return get(`${urlApiTegra}/projects/chart?${query}`, token);
};


export { getCollaboratorChartsDate, getProjectsChartsDate };
